// src/pages/menu/LoungeWaitersDashboard.jsx
import React from 'react';
import LocationWaitersDashboard from '../LocationWaitersDashboard';

const LoungeWaitersDashboard = () => {
  return <LocationWaitersDashboard locationKey="lounge" />;
};

export default LoungeWaitersDashboard;